// extracted by mini-css-extract-plugin
export default {"container":"InvestorManagement_container__AIWNF","title":"InvestorManagement_title__HmySD"};